export function expandPieceIdPattern(pattern: string, index: number): string {
  return pattern.replace('{index}', String(index));
}
